import React from "react"
import ContentLoader from "react-content-loader"

const Placeholder2 = () => (
    <ContentLoader speed={2} backgroundColor="#ffffff" foregroundColor="#f0f0f0" width="100%">
        <rect x="4" y="63" rx="3" ry="3" width="99.1%" height="80" />
        <rect x="4" y="40" rx="3" ry="3" width="30%" height="15" />
    </ContentLoader>
)

export default Placeholder2
